<template>
  <section class="work section">
    <div class="container">
      <router-link
        data-aos="fade-right"
        data-aos-delay="200"
        class="back"
        to="/"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          width="25"
          height="25"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
          />
        </svg>
        <span>Back</span>
      </router-link>
    </div>
    <div class="section-center">
      <h2 class="section__title text-title link-title">
        <span data-aos="zoom-in">All Works.</span>
      </h2>
    </div>
    <span class="section__subtitle" data-aos="zoom-out" data-aos-delay="300"
      >Some of my works</span
    >
    <div
      data-aos="fade-down"
      v-if="projetsCurrent[0]"
      class="work__container container grid"
    >
      <div
        v-for="(projet, index) in projetsCurrent"
        :key="index"
        class="work__card"
        @click="openLink(projet.link)"
      >
        <img
          @dblclick="showDescription(index)"
          :src="projet.img"
          :alt="projet.title"
          class="work__img"
        />
        <div class="details__projets">
          <h3 class="work__title">{{ projet.title }}</h3>
        </div>
        <p class="description__project">
          {{ projet.description }}
          <span class="underline">
            <span>View</span
            ><svg viewBox="0 0 13 20">
              <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5" />
            </svg>
          </span>
        </p>
      </div>
    </div>

    <div v-else>
      <p class="empty__projet">Disponible bientôt 😇.</p>
    </div>
  </section>
  <div v-if="displayModal">
    <modal-projet :projet="projet"></modal-projet>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ModalProjet from "@/components/ModalProjet.vue";
export default {
  components: {
    ModalProjet,
  },

  data() {
    return {
      titre: "Projets.",
      img_projet: require("../assets/img/projet.png"),
      search: "",
      prec: ".prec",
      suiv: ".suiv",
      none: "none",
      block: "block",
      btnPrev: ".btn-prec",
      btnNext: ".btn-suiv",
      showModal: false,
      projetsCurrent: [],
      categorie: "recent",
      optionsCategory: [
        {
          name: "Récents",
          value: "recent",
        },
        {
          name: "Front-End",
          value: "frontend",
        },
      ],
      // mixerProjet:""
    };
  },

  methods: {
    openLink(url) {
      window.open(url, "_blank");
    },

    showDescription(i) {
      this.projet = this.projets[i];
      this.$store.commit("setDisplayModal", true);
    },

    changeCategory() {
      if (this.categorie === this.optionsCategory[0].value) {
        this.projetsCurrent = this.projets;
      } else {
        this.projetsCurrent = this.projetsFront;
      }
    },
  },

  computed: {
    filterProjet() {
      return this.projets.filter((projet) => {
        return projet.title.toLowerCase().includes(this.search.toLowerCase());
      });
    },

    ...mapGetters(["projets", "projetsFront", "displayModal"]),
  },

  mounted() {
    this.changeCategory();
  },
};
</script>
<style scoped>
@import url("../assets/css/projet.css");

.empty__projet {
  text-align: center;
  font-size: 25px;
  font-weight: 600;
}

.back {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 40px;
  font-size: var(--normal-font-size);
  width: max-content;
  padding: 16px;
  border-radius: 25px;
  color: var(--text-color);
  box-shadow: 0 0 3px var(--first-color);
  cursor: pointer;
  margin-top: 20px;
  margin-bottom: 20px;
}
.back svg {
  transform: translateX(0);
  transition: transform 0.5s ease;
}
.back:hover {
  box-shadow: 0 0 8px var(--first-color);
  transition: box-shadow 0.2s ease;
}
.back:hover svg {
  transform: translateX(-6px);
}
</style>
